module.exports = __webpack_public_path__ + "static/media/current-account.f70e9d84.svg";